export default __webpack_public_path__ + "images/ff912b7401ca493d233113d50fbca1cd-denver_mobile.webp";